import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullDealFragment from "@irati/deals/services/queries/fragments/fullDeal"
import fullDealsTagFragment from "@irati/deals/services/queries/fragments/fullDealsTag"

export const query = gql`
  query HomepageLanes($kind: HomepageKind) {
    homepageLanes(kind: $kind) {
      results {
        linkedEntityUrl
        seeMoreUrl
        type
        headerText
        bodyText
        deals {
          ...fullDeal
        }
        tag {
          ...fullDealsTag
        }
        image
      }
    }
  }
  ${fullDealFragment}
  ${fullDealsTagFragment}
`

export const homepageLanesKey = getQueryNames(query)[0]

export default query
